document.addEventListener('DOMContentLoaded', function () {
	class MobileMenuToggle extends HTMLElement {
		constructor() {
			super()
			
			this.trigger = document.querySelector('#coco-mobile-menu-trigger')
			this.menu = document.querySelector('#coco-mobile-menu')
			this.isOpen = false
			
			this.init()
		}

		init() {
			if (!this.trigger || !this.menu) return
			
			// Set up trigger click handler
			this.trigger.addEventListener('click', (e) => {
				e.preventDefault()
				this.toggle()
			})

			// Set up escape key handler
			document.addEventListener('keydown', (e) => {
				if (e.key === 'Escape' && this.isOpen) {
					this.close()
				}
			})

			// Set up click outside handler
			document.addEventListener('click', (e) => {
				if (this.isOpen && !this.menu.contains(e.target) && !this.trigger.contains(e.target)) {
					this.close()
				}
			})

			// Set up scroll detection for mobile menu positioning
			this.setupScrollDetection()
			
			// Set up mobile menu dropdown functionality
			this.setupMobileMenuDropdowns()
		}

		setupScrollDetection() {
			const updateMobileMenuPosition = () => {
				const countdownBanner = document.querySelector('.section-countdown-timer-bar')
				const scrollTop = window.pageYOffset || document.documentElement.scrollTop

				if (countdownBanner) {
					const countdownHeight = countdownBanner.offsetHeight

					if (scrollTop > countdownHeight) {
						// Remove the larger max-height class and add the smaller one
						this.menu.classList.remove('max-h-[calc(100svh-5.8rem-var(--header-height))]')
						this.menu.classList.add('max-h-[calc(100svh-1.6rem-var(--header-height))]')
					} else {
						// Remove the smaller max-height class and add the larger one
						this.menu.classList.remove('max-h-[calc(100svh-1.6rem-var(--header-height))]')
						this.menu.classList.add('max-h-[calc(100svh-5.8rem-var(--header-height))]')
					}
				}
			}

			// Initial call
			updateMobileMenuPosition()
			
			// Add scroll and resize listeners
			window.addEventListener('scroll', updateMobileMenuPosition)
			window.addEventListener('resize', updateMobileMenuPosition)
		}

		setupMobileMenuDropdowns() {
			// Find all mobile menu dropdown triggers
			const dropdownTriggers = document.querySelectorAll('.mobile-menu-dropdown-trigger')
			
			dropdownTriggers.forEach(trigger => {
				trigger.addEventListener('click', (e) => {
					e.preventDefault()
					e.stopPropagation()
					
					// Find the corresponding dropdown list
					const dropdown = trigger.closest('.mobile-menu-dropdown')
					const dropdownList = dropdown.querySelector('.mobile-menu-dropdown-list')
					
					if (dropdownList) {
						const isOpen = dropdownList.style.height !== '0px' && dropdownList.offsetHeight > 0
						
						if (isOpen) {
							this.closeDropdown(dropdownList, trigger)
						} else {
							this.openDropdown(dropdownList, trigger)
						}
					}
				})
			})
		}

		openDropdown(dropdownList, trigger) {
			// Temporarily set height to auto to get the natural content height
			dropdownList.style.height = 'auto'
			dropdownList.style.overflow = 'hidden'
			const contentHeight = dropdownList.offsetHeight
			if (trigger) {
				trigger.classList.add('is-active')
				trigger.setAttribute('aria-expanded', 'true')
			}
			
			// Reset to 0 for animation
			dropdownList.style.height = '0px'
			
			// Use requestAnimationFrame for smooth animation
			requestAnimationFrame(() => {
				dropdownList.style.transition = 'height 0.5s cubic-bezier(0.4, 0, 0.2, 1)'
				dropdownList.style.height = contentHeight + 'px'
				
				// Set height to auto after animation completes
				setTimeout(() => {
					dropdownList.style.height = 'auto'
					dropdownList.style.transition = ''
				}, 500)
			})
		}

		closeDropdown(dropdownList, trigger) {
			// Get current height
			const currentHeight = dropdownList.offsetHeight
			const dropdown = dropdownList.closest('.mobile-menu-dropdown')
			const dropdownTrigger = trigger || dropdown?.querySelector('.mobile-menu-dropdown-trigger')

			if (dropdownTrigger) {
				dropdownTrigger.classList.remove('is-active')
				dropdownTrigger.setAttribute('aria-expanded', 'false')
			}
			
			// Set height to current height and add transition
			dropdownList.style.height = currentHeight + 'px'
			dropdownList.style.transition = 'height 0.5s cubic-bezier(0.4, 0, 0.2, 1)'
			
			// Use requestAnimationFrame for smooth animation
			requestAnimationFrame(() => {
				dropdownList.style.height = '0px'
				
				// Clean up after animation
				setTimeout(() => {
					dropdownList.style.transition = ''
					dropdownList.style.height = '0px'
				}, 500)
			})
		}

		closeAllDropdowns() {
			// Find all mobile menu dropdown lists and close them
			const dropdownLists = document.querySelectorAll('.mobile-menu-dropdown-list')
			
			dropdownLists.forEach(dropdownList => {
				this.closeDropdown(dropdownList)
			})
		}

		toggle() {
			if (this.isOpen) {
				this.close()
			} else {
				this.open()
			}
		}

		open() {
			if (this.isOpen) return
			
			this.isOpen = true
			
			// Add active class to trigger
			this.trigger.classList.add('active')
			
			// Remove Tailwind classes to show menu with animation
			this.menu.classList.remove('translate-y-[1rem]', 'pointer-events-none', 'opacity-0')
			
			// Prevent body scroll
			// document.body.style.overflow = 'hidden'
			
			// Focus management
			const focusableElements = this.menu.querySelectorAll(
				'a[href], button, [tabindex]:not([tabindex="-1"])'
			)
			if (focusableElements.length > 0) {
				focusableElements[0].focus()
			}
		}

		close() {
			if (!this.isOpen) return
			
			this.isOpen = false
			
			// Remove active class from trigger
			this.trigger.classList.remove('active')
			
			// Add Tailwind classes to hide menu with animation
			this.menu.classList.add('translate-y-[1rem]', 'pointer-events-none', 'opacity-0')
			
			// Close all dropdowns with delay after menu starts closing
			setTimeout(() => {
				this.closeAllDropdowns()
			}, 200)
			
			// Restore body scroll
			// document.body.style.overflow = ''
			
			// Return focus to trigger
			if (this.trigger) {
				this.trigger.focus()
			}
		}
	}

	// Initialize the mobile menu toggle
	customElements.define('mobile-menu-toggle', MobileMenuToggle)
	
	// Create and append the mobile menu toggle element
	const mobileMenuToggle = document.createElement('mobile-menu-toggle')
	document.body.appendChild(mobileMenuToggle)
})
